/**
 * Handles mobile navigation menu behavior for specific product page
 * - Shows/hides sticky navigation based on scroll position
 * - Only activates on mobile devices and specific product page
 */
export const navigationMenuMobileSonicsmooth = () => {
  const validPaths  = [
    '/pages/sonicsmooth-pro-plus-12',
    '/pages/sonicsmooth-pro-plus-40'
  ];

  const isCorrectPage = validPaths.some(path => window.location.pathname.includes(path));
  const isMobile = window.innerWidth <= 550;

  // Early return if conditions aren't met
  if (!isCorrectPage || !isMobile) {return}

  const navigationBar = document.querySelector('.navigation-menu-mobile');
  if (!navigationBar) {return}

  // State variables
  let lastScrollTop = 0;
  let addToCartButton = null;
  let isStickyActive = false;

  /**
   * Checks if the navigation should be sticky based on ATC button position
   */
  const checkStickyStatus = () => {
    const atcButtonRect = addToCartButton.getBoundingClientRect();
    const shouldBeSticky = atcButtonRect.bottom < 0;

    if (shouldBeSticky) {
      navigationBar.classList.add('sticky');
      isStickyActive = true;
    } else {
      navigationBar.classList.remove('sticky');
      isStickyActive = false;
      navigationBar.classList.remove('pdm-replo-hidden');
    }
  };

  /**
   * Handles scroll behavior for sticky navigation
   */
  const handleScroll = () => {
    const currentScrollTop = window.pageYOffset || document.documentElement.scrollTop;

    checkStickyStatus();

    if (isStickyActive) {
      navigationBar.classList.toggle('pdm-replo-hidden', currentScrollTop < lastScrollTop);
    }

    lastScrollTop = Math.max(0, currentScrollTop);
  };

  /**
   * Initializes scroll logic if ATC button exists
   */
  const initializeScrollLogic = () => {
    window.addEventListener('scroll', handleScroll);
    requestAnimationFrame(checkStickyStatus);
  };

  // Find and validate Add to Cart button
  const addToCartButtonElement = document.querySelector('#add-to-cart');
  if (addToCartButtonElement?.offsetHeight > 0) {
    addToCartButton = addToCartButtonElement;
    initializeScrollLogic();
  }
};
